/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { Configuration } from '../../../Configuration';
import { RestServiceProvider } from '../../RestServiceProvider';
import { GuaranteedRestoreTimePolicyService } from './GuaranteedRestoreTimePolicyService';

class GuaranteedRestoreTimePolicyServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new GuaranteedRestoreTimePolicyService($q, resource, $httpParamSerialiserJQLike, $log);
    }

    getUpdateEntitiesConfig(url) {
        return {
            url: url + Configuration.BULK_PATH,
            method: 'PUT',
            isArray: true,
            transformResponse:
                (data, headers, status) => ((status === 401) || (status === 403)) ? [] : angular.fromJson(data)
        };
    }

    /** @ngInject */
    getConfig() {
        const config = super.getConfig();
        config.updateEntities = this.getUpdateEntitiesConfig(this.resourceUrl);
        return config;
    }
}

export { GuaranteedRestoreTimePolicyServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/GuaranteedRestoreTimePolicyServiceProvider.js